module.exports = __webpack_public_path__ + "static/media/coinsflare.bf8b26f1.png";